import ApiDelete from "../../../../api-controller-mod/api-serv/delete-api/deleteApi";
import ApiGet from "../../../../api-controller-mod/api-serv/get-api/getApi";
import { BadgeVariant } from "../../../../component-controller-mod/component-serv/badge-fs-cp/dynamic-badge-op/ts/statusBadge";
import { API_ENDPOINTS } from "../../../../context-controller-mod/context-serv/global-provider/api-shell/api-provider";

export const status = [
  { value: 'all', label: 'All' },
  { value: 'read', label: 'Read' },
  { value: 'new', label: 'New' },
];

export const TypeBussiness = [
  { value: 'all', label: 'All' },
  { value: 'business', label: 'Business' },
  { value: 'sale', label: 'Sale' },
];

export const columns = ['ID', 'Contact name', 'Type', 'Email', 'Phone', 'Status', 'Action'];

export type InboxRow = {
  id: string;
  ID: string;
  "Contact name": string;
  Type: string;
  Email: string;
  Phone: string;
  Status: string;
  _raw?: InboxItem;
  Action?: React.ReactNode;
};

export type InboxItem = {
  id?: string | number;
  contactId?: string | number;
  fullName?: string;
  name?: string;
  categoryName?: string;
  contactType?: string;
  email?: string;
  phone?: string;
  phoneNumber?: string;
  status?: string;
};

export type InboxPagination = {
  page: number;
  size: number;
  totalRecords: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
};

export type InboxApiResponse = {
  data?: {
    items?: InboxItem[];
    pagination?: InboxPagination;
  };
};

export type InboxAttachment = {
  id: string;
  filename: string;
  mimeType?: string;
  fileSize?: number; 
  url?: string;
  downloadUrl?: string | null;
};

export type InboxDetail = {
  id: string;               
  fullName?: string;
  email?: string;
  phone?: string;
  company?: string;
  subject?: string;
  message?: string;
  status?: string;            
  categoryName?: string;     
  createdAt?: string;
  updatedAt?: string;
  attachments?: InboxAttachment[];
};

export type InboxDetailApiResponse = {
  data?: InboxDetail;
};

export const getInboxApi = (
  page = 1,
  size = 10,
  filters?: { status?: string; category?: string; search?: string }
) =>
  ApiGet<InboxApiResponse>(API_ENDPOINTS.GET_INBOX, {
    params: {
      page,
      size,
      ...(filters?.status && filters.status !== "all" ? { status: filters.status } : {}),
      ...(filters?.category && filters.category !== "all" ? { category: filters.category } : {}),
      ...(filters?.search ? { search: filters.search } : {}),
    },
  });

export const getInboxDetailApi = (inboxUuid: string) =>
  ApiGet<InboxDetailApiResponse>(API_ENDPOINTS.GET_INBOX_DETAIL, {
    params: { inboxUuid },
  });

export const deleteInboxItem = (inboxId: string) =>
  ApiDelete(API_ENDPOINTS.DELETE_INBOX, {
    params: { inboxId },
  });

export const toBadgeVariant = (value?: string): BadgeVariant => {
  switch (value?.toLowerCase()) {
    case "published":
      return "published";
    case "unpublished":
    case "unpublish":
      return "unpublished";
    case "draft":
      return "draft";
    case "new":
      return "new";
    case "reviewed":
      return "reviewed";
    case "shortlisted":
      return "shortlisted";
    case "interviewed":
      return "interviewed";
    case "rejected":
      return "rejected";
    case "hired":
      return "hired";
    default:
      return "draft";
  }
};

export const formatBytes = (bytes?: number) => {
  if (bytes == null) return "-";
  if (bytes < 1024) return `${bytes} B`;
  const kb = bytes / 1024;
  if (kb < 1024) return `${kb.toFixed(1)} KB`;
  return `${(kb / 1024).toFixed(1)} MB`;
};

export const normalizeSearch = (s: string) =>
  s.replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

export const batchDeleteInboxContacts = (ids: string[]) =>
  ApiDelete(API_ENDPOINTS.BATCH_DELETE_INBOX_CONTACT, {
    data: { ids },
  });

  